import type { Selector, State as S } from 'model/State';

// TODO: Replace with an appropriate type
export const selectCartOrder = (orderId: number, state: S) =>
  state?.mac.cart.order?.[orderId]?.ifSuccess((r) => r);

export const selectCartSource: Selector<unknown> = (state: S) =>
  state.mac.cart.source?.ifSuccess((r) => r);

export const selectPurchaseOrderNumberUpdated = (poNumber: string, state: S) =>
  state.mac.cart.purchaseOrderNumberUpdated?.[poNumber]?.ifSuccess((r) => r);

export const selectPurchaseOrderNumberUpdatedError = (poNumber: string, state: S) =>
  state.mac.cart.purchaseOrderNumberUpdated?.[poNumber]?.error;
